import { Colors } from "../../consts/Colors";
import Obstacle from "../Obstacle";

export default class Dcp extends Obstacle {
    constructor(scene, x, y, params = { showHitbox: true }) {
        super(scene, x, y, params);

        this.scene = scene;
        this.type = 'dcp'
        this.speed= 420
        scene.add.existing(this);
    }

    addBody(params) {
        // this.texture = this.scene.add.sprite(0, 0, 'birds').setOrigin(0, 0.5)
        // this.texture.anims.play('birdsAnim');
        this.texture = this.scene.add.image(0, 0, 'dcp').setOrigin(0, 0.5)

        this.add(this.texture)


        this.scene.tweens.add({
            targets: this,
            y: this.y + 10*0.36,
            duration: 900,
            ease: 'Linear',
            repeat: -1,
            yoyo: true
        })

        this.addHitbox()
        this.displayHitbox(params.showHitbox)


        this.width = this.texture.width
    }

    addHitbox() {
        this.hitbox = this.scene.add.rectangle(this.texture.width/2, 0, this.texture.width*0.8, this.texture.height*0.8, Colors.Elmt.Black, 0.4).setOrigin(0.5)
        this.add(this.hitbox)
    }

    displayHitbox(isVisible) {
        this.hitbox.setAlpha(isVisible ? 1 : 0)
    }
}